import { gql } from 'graphql-tag'

/**
 * Upserts a single setting for the current user.
 */
export const SET_USER_SETTING_MUTATION = gql`
  mutation SetUserSetting($key: String!, $value: JSON!) {
    setUserSetting(key: $key, value: $value)
  }
`

/**
 * Admin-only: upserts a setting for an arbitrary user.
 */
export const SET_USER_SETTING_FOR_MUTATION = gql`
  mutation SetUserSettingFor($userId: ID!, $key: String!, $value: JSON!) {
    setUserSettingFor(userId: $userId, key: $key, value: $value)
  }
`
